import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Login_User } from "../../api/userAuth";
import { showToastMessage } from "../../utils/toastUtils";
import { isUsername, sanitizeInput, validateFields } from "../../utils/validators";
import AuthShell from "../../components/auth/AuthShell";
import { AuthField, AuthPasswordInput } from "../../components/auth/AuthField";

const SignupForm = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { valid, errors } = validateFields({
      username: () => isUsername(form.username),
      password: () =>
        !form.password
          ? "Password is required"
          : form.password.length < 6
            ? "Password must be at least 6 characters"
            : null,
    });
    if (!valid) {
      showToastMessage("error", Object.values(errors)[0]);
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        userName: sanitizeInput(form.username).trim().toUpperCase(),
        password: form.password,
      };
      const result = await Login_User(payload);

      if (result.success) {
        const response = result?.data?.user || {};
        if (response.isActive) {
          showToastMessage(
            "success",
            result.message || "Account Logged Successfully!"
          );
          setForm({ username: "", password: "" });
          navigate(`/verify/mpin/${response?.userName}`);
        } else {
          showToastMessage("error", "Account not active. Contact Admin.");
        }
      } else {
        showToastMessage("error", result?.message || "Login failed!");
      }
    } catch {
      showToastMessage("error", "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Admin access"
      title="Sign in to Admin Panel"
      subtitle="Enter your admin username and password to continue."
    >
      <form
        onSubmit={handleSubmit}
        noValidate
        autoComplete="off"
        className="flex flex-col gap-3.5"
      >
        <AuthField label="Username" required>
          <input
            className="ds-input"
            placeholder="Enter Username"
            value={form.username}
            onChange={(e) =>
              setForm({ ...form, username: e.target.value.toUpperCase() })
            }
            style={{ textTransform: "uppercase" }}
            autoComplete="username"
          />
        </AuthField>

        <AuthField label="Password" required>
          <AuthPasswordInput
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            show={showPassword}
            onToggle={() => setShowPassword((v) => !v)}
          />
        </AuthField>

        <button
          type="submit"
          className="ds-btn ds-btn-primary ds-btn-block"
          disabled={submitting}
        >
          {submitting ? "Please wait..." : "Get Started"}
        </button>
      </form>
    </AuthShell>
  );
};

export default SignupForm;
